<template>
  <div class="pb50" v-loading="loading">
    <div class="product-content">

      <!-- 消费汇总 -->
      <div class="common-form">消费概览</div>
      <div class="table-wrap">
        <el-row :gutter="20">
          <el-col :span="5">
            <div class="pb16"><span class="gray9">完成订单数：</span>{{ summary.order_count || 0 }}</div>
          </el-col>
          <el-col :span="5">
            <div class="pb16"><span class="gray9">净消费（$）：</span>{{ summary.total_spend || '0.00' }}</div>
          </el-col>
          <el-col :span="5">
            <div class="pb16"><span class="gray9">复购次数：</span>{{ summary.repurchase_count || 0 }}</div>
          </el-col>
          <el-col :span="6">
            <div class="pb16">
              <span class="gray9">最近下单：</span>
              {{ summary.last_order_time | timeFormat }}
            </div>
          </el-col>
        </el-row>
        <p class="gray9" style="font-size:12px">
          统计口径：净消费 = 实付金额 - 退款金额，仅统计已完成（order_status=30）且已付款订单；复购次数 = 完成订单数 - 1
        </p>
      </div>

      <!-- 预约历史 -->
      <div class="common-form mt16">预约历史</div>
      <div class="table-wrap">
        <el-table size="small" :data="orders.data" border style="width: 100%">
          <el-table-column prop="order_no" label="订单号" width="200" />
          <el-table-column label="服务项目">
            <template slot-scope="scope">
              <div v-for="item in scope.row.service" :key="item.order_service_id">
                {{ item.service_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="实付（$）" width="100">
            <template slot-scope="scope">{{ scope.row.pay_price }}</template>
          </el-table-column>
          <el-table-column label="状态" width="90">
            <template slot-scope="scope">{{ scope.row.order_status_text }}</template>
          </el-table-column>
          <el-table-column label="下单时间" width="160">
            <template slot-scope="scope">{{ scope.row.create_time | timeFormat }}</template>
          </el-table-column>
<!--          <el-table-column fixed="right" label="操作" width="80">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button type="text" size="small" @click="toOrder(scope.row.order_id)">详情</el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <div class="pagination" v-if="orders.total > pageSize">
          <el-pagination
            @current-change="handleOrderPage"
            background
            :current-page="orderPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="orders.total"
          ></el-pagination>
        </div>
      </div>

      <!-- 评价记录 -->
      <div class="common-form mt16">评价记录</div>
      <div class="table-wrap">
        <el-table size="small" :data="comments" border style="width: 100%">
          <el-table-column label="服务" width="200">
            <template slot-scope="scope">
              {{ scope.row.OrderService && scope.row.OrderService.service_name }}
            </template>
          </el-table-column>
          <el-table-column label="评分" width="160">
            <template slot-scope="scope">
              <el-rate :value="scope.row.score" disabled show-score text-color="#ff9900" />
            </template>
          </el-table-column>
          <el-table-column prop="content" label="内容" />
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="mini">
                {{ scope.row.status === 1 ? '已显示' : '待审核' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="时间" width="160">
            <template slot-scope="scope">{{ scope.row.create_time | timeFormat }}</template>
          </el-table-column>
        </el-table>
      </div>

    </div>

    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="$router.back()">返回</el-button>
    </div>
  </div>
</template>

<script>
import CustomerApi from '@/api/customer.js'

export default {
  name: 'CustomerDetail',
  filters: {
    timeFormat(val) {
      if (!val) return '-'
      // TP6 返回字符串时直接 new Date；返回整数时乘 1000
      const d = typeof val === 'number' ? new Date(val * 1000) : new Date(val.replace(/-/g, '/'))
      return isNaN(d.getTime()) ? val : d.toLocaleString('zh-CN', { hour12: false })
    }
  },
  data() {
    return {
      loading: true,
      user_id: null,
      summary: {},
      orders: { data: [], total: 0 },
      comments: [],
      orderPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.user_id = this.$route.query.user_id
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      CustomerApi.detail({
        user_id: this.user_id,
        page: this.orderPage,
        list_rows: this.pageSize
      }).then(res => {
        this.summary = res.data.summary || {}
        this.orders = res.data.orders || { data: [], total: 0 }
        this.comments = res.data.comments || []
        this.loading = false
      })
    },
    handleOrderPage(val) {
      this.orderPage = val
      this.getData()
    },
    toOrder(order_id) {
      this.$router.push({ path: '/order/order/detail', query: { order_id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/order/customer/detail.vue